<div
    role="tabpanel"
    [id]="id + '.panel'"
    class="agpr-tab"
    [style.display]="selected && !hidden ? '' : 'none'"
    [attr.aria-labelledby]="id"
>
    @if (selectedTabIndex !== sortToolTabIndex || briefing?.isPreviewMode) {
        <agpr-scroll-panel #scrollPanel>
            <div
                class="agpr-briefingComposeTab-blocks u-mdBottomMargin"
                [ngClass]="{'agpr-briefingComposeTab-blocks--canvas': briefing?.deliveryMethod === briefingDeliveryMethods.ONLINE}"
            >
                <div
                    class="agpr-briefingComposeTab-blocksInner"
                    [ngClass]="{
                        'agpr-briefingComposeTab-blocksInner--canvas': briefing?.deliveryMethod === briefingDeliveryMethods.ONLINE,
                        'agpr-briefingComposeTab-blocksInner--previewMode': briefing?.isPreviewMode
                    }"
                >
                    <!-- The compose tab should not be exposed for published briefings -->
                    @if (briefing.status !== briefingStatusEnum.SENT) {
                        <agpr-page-builder
                            [showPlaceholder]="true"
                            (blockAdded)="scrollToAddedBlock.next($event)"
                            [inlineAdderAdjustment]="inlineAdderAdjustment"
                            [actionMenuTextAlignment]="actionMenuTextAlignment"
                        ></agpr-page-builder>

                        @if (showNoBlocksSelectedErrorMsg && !loadingBriefing && !briefing.blocks?.length) {
                            <agpr-message [severity]="messageSeverityEnum.error">
                                {{ 'Briefings.error.blockRequired' | localize }}
                            </agpr-message>
                        }

                        @if (briefing?.deliveryMethod === briefingDeliveryMethods.ONLINE) {
                            <div class="agpr-briefingComposeTab-canvasFooter">
                                <span>{{ 'Monitor.briefings.canvasFooter' | localize }}</span>
                                <img
                                    src="assets/images/agility-logo-horizontal.png"
                                    alt="Agility PR Solutions"
                                >
                            </div>
                        }
                    }
                </div>
            </div>
        </agpr-scroll-panel>
    } @else if (selectedTabIndex === sortToolTabIndex && !briefing?.isPreviewMode) {
        <div class="agpr-briefingComposeTab-sortTool u-mdBottomMargin">
            <agpr-sort-tool
                #sortTool
                [id]="id + '.sortTool'"
                (selectedMentionChange)="selectedMentionChange.next($event)"
                (selectBlockEditTab)="selectBlockEditTab.next()"
                (draggingMentions)="doDraggingMentions.next($event)"
            ></agpr-sort-tool>
        </div>
    }
</div>
